<template>
    <header class="header-wrap">
        <div
            class="header-wrap__main"
            :class="{ 'header-wrap__login': $route.path === '/login' }"
        >
            <img
                v-if="$route.path !== '/login'"
                src="@/assets/images/aiop-logo.png"
                @click="toHome"
            />
            <img v-else src="@/assets/images/login-logo.png" @click="toHome" />
            <nav v-if="$route.path !== '/login'">
                <ul>
                    <li
                        v-for="(item, index) in menuData"
                        :key="index"
                        :class="{ active: hasActived(item.type) }"
                        @click="handleClickMenu(item)"
                    >
                        {{ item.name }}
                    </li>
                </ul>
                <div class="userInfo">
                    <template v-if="userInfo.account">
                        <span>{{ userInfo.account }} </span>
                        <span class="pointer" @click="logout">退出</span>
                    </template>
                    <template v-else>
                        <span class="c-999 pointer" @click="login">
                            <template v-if="$route.name === 'register'">
                                已有账号？
                            </template>
                            登录
                        </span>
                        <span
                            class="c-999 pointer"
                            v-if="$route.name !== 'register'"
                            @click="register"
                        >
                            注册
                        </span>
                    </template>
                </div>
            </nav>
        </div>
    </header>
</template>
<script>
import { logoutServ } from '@/api/login.api';
import { mapState } from 'vuex';
export default {
    name: 'ak-header',
    props: {
        current: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            menuData: [
                {
                    name: 'API文档',
                    type: 'api'
                },
                {
                    name: '文档中心',
                    type: 'docCenter'
                },
                {
                    name: '平台公告',
                    type: 'notice'
                },
                {
                    name: '控制台',
                    type: 'control'
                }
            ]
        };
    },
    computed: {
        ...mapState('sys', ['userInfo']),
        hasActived() {
            return function(type) {
                if (!this.$route.name) {
                    return false;
                } else {
                    return this.$route.name.indexOf(type) === 0;
                }
            };
        }
    },
    methods: {
        toHome() {
            this.$router.push('/');
        },
        handleClickMenu(item) {
            if (item.type === 'api') {
                if (this.$route.path !== '/') {
                    this.$router.push({ path: '/' });
                }
            } else if (item.type === 'docCenter') {
                this.$router.push({ path: '/docCenter' });
            } else if (item.type === 'notice') {
                this.$router.push({ path: '/notice' });
            } else {
                this.$router.push({ path: '/control' });
            }
        },
        handleCommand(val) {
            const path = val === 'api' ? '/' : `/${val}`;
            this.$router.push({ path });
        },
        async logout() {
            await logoutServ();
            this.$store.dispatch('sys/logout');
        },
        login() {
            this.$router.replace({
                path: '/login',
                query:
                    this.$route.name === 'register'
                        ? {}
                        : {
                              redirect:
                                  window.location.pathname +
                                  window.location.search
                          }
            });
        },
        register() {
            this.$router.replace({
                path: '/register'
            });
        }
    }
};
</script>
<style lang="scss" scope>
.el-dropdown-menu__item {
    width: 160px !important;
    text-align: center !important;
    padding: 15px 0 !important;
    color: #5a5f66 !important;
    font-weight: 500;
    &.active {
        color: #ff585e !important;
    }
    &:hover {
        background: #fef0f0 !important;
    }
}
.header-wrap {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 64px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.03);
    border-top: 2px solid #ff585e;
    &__main {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 1160px;
        height: 100%;
        overflow: hidden;
        margin: 0 auto;
        img {
            width: 183px;
            height: 29px;
            vertical-align: middle;
        }
        nav {
            display: flex;
            align-items: center;
            margin-left: 17px;
            text-align: right;
            ul {
                margin-right: 80px;
                li {
                    padding: 0 0 0 40px;
                    text-align: right;
                    line-height: 22px;
                    display: inline-block;
                    font-size: 16px;
                    color: #303133;
                    &:hover {
                        cursor: pointer;
                    }
                    &.active {
                        color: $color-red;
                    }
                    .el-dropdown {
                        span {
                            font-size: 16px;
                        }
                        &.active {
                            span {
                                font-size: 16px;
                                color: $color-red;
                            }
                        }
                    }
                }
            }
            .userInfo {
                span {
                    font-size: 14px;
                    color: #333333;
                }
                span:last-child {
                    padding: 10px;
                    margin: 0;
                }
            }
        }
    }
    &__login {
        width: 100%;
        padding-left: 126px;
        padding-right: 126px;
        box-sizing: border-box;
    }
}
</style>
